"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnv = exports.default = void 0;

var _cookie = _interopRequireDefault(require("../cookie"));

var _dev = _interopRequireDefault(require("./env/dev"));

var _test = _interopRequireDefault(require("./env/test"));

var _pre = _interopRequireDefault(require("./env/pre"));

var _prd = _interopRequireDefault(require("./env/prd"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var configs = {
  dev: _extends({}, _dev.default),
  test: _extends({}, _test.default),
  pre: _extends({}, _pre.default),
  prd: _extends({}, _prd.default)
};
var list = ['dev', 'test', 'pre', 'prd'];
var env = list[3];

if (_cookie.default.get('_e')) {
  env = list[_cookie.default.get('_e')];
} else if (typeof window !== 'undefined') {
  var _window$location = window.location,
      host = _window$location.host,
      hostname = _window$location.hostname; // 本地开发

  if (['127.0.0.1', 'localhost'].indexOf(hostname) >= 0) {
    // eslint-disable-next-line prefer-destructuring
    env = list[0];
  } else {
    var hostList = ['dev', 'test', 'uat'];
    var findIndex = null;
    hostList.map(function (key, i) {
      if (new RegExp(key).test(host)) {
        findIndex = i;
      }

      return i;
    });
    env = findIndex !== null ? list[findIndex] : env;
  }
}

var config = configs[env]; // 获取环境

var getEnv = function getEnv() {
  return env;
};

exports.getEnv = getEnv;
var _default = config;
exports.default = _default;